module.exports = __webpack_public_path__ + "img/bar.e4cf22d9.svg";